var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","display":"flex","align-items":"center","justify-content":"center","font-size":"clamp(18px,3vw,50px)","font-weight":"500"}},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }